import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"upload\"><defs><style>#upload .cls-1{fill:none;}</style></defs><title>资源 1</title><g id=\"upload_图层_2\" data-name=\"图层 2\"><g id=\"upload_Group_54\" data-name=\"Group 54\"><rect id=\"upload_Rectangle_36\" data-name=\"Rectangle 36\" class=\"cls-1\" width=\"24\" height=\"24\" /><g id=\"upload_plus\"><path id=\"upload_Shape\" d=\"M20.24,11.16H12.77V3.88A.83.83,0,0,0,11.93,3h0a.83.83,0,0,0-.84.84h0v7.28H3.79a.84.84,0,0,0-.85.84h0a.84.84,0,0,0,.84.84h7.31v7.3a.84.84,0,0,0,.84.85h0a.84.84,0,0,0,.84-.84h0v-7.3h7.47a.84.84,0,0,0,.85-.84h0a.84.84,0,0,0-.85-.84Z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/upload.svg
// module id = ZMih
// module chunks = 6